<template>
    <div class="col-lg">
        <div class="card mb-3 d-none d-md-block">
            <div class="row g-0">
                <router-link class="img-card horizontal" :to="{name: 'Product', params:{id:product.id}}">
                    <img :src="product.img[product.defaultImg]" class="img-card horizontal">
                </router-link>
                <div class="col bg-light">
                    <div class="card-body">
                        <router-link :to="{name: 'Product', params:{id:product.id}}" class="card-title h5">{{product.name}}</router-link>
                        <Categories :categories="product.categories" />
                    </div>
                </div>
            </div>
        </div>
        <router-link :to="{name :'Product', params:{id:product.id}}" class="card bg-dark text-white d-md-none mb-2 border-0">
            <img :src="product.img[product.defaultImg]" class="img-card">
            <div class="card-img-overlay">
                <h5 class="card-title text-white">{{product.name}}</h5>
                <Categories :categories="product.categories" />
            </div>
        </router-link>
    </div>
</template>

<script>
import Categories from './Categories';

export default {
    name: 'Product',
    props: ['product'],
    components:{
        Categories
    }
}
</script>

<style lang="scss" scoped>
.card{
    overflow: hidden;
    & .img-card{
        object-fit: cover;
        object-position: center;
        height: 40vw;
        &.horizontal{ 
            width: 15vw;
            height: 15vw;
        }
    }
    & .card-img-overlay{
        background:rgba(0,0,0,0.5);
    }
    & .card-title{
        color: black;
        text-decoration: none;
        transition: 0.5s all;
        &:hover{
            color: black;
        }
    }
    & .card-links{
        position: absolute;
        bottom: 1rem;
        right: 1rem;
    }
}
</style>